export enum TaskActionsEnum {
  order = 5,
  inventory = 6,
  inspection = 7,
  refill = 8,
  cashClosing = 9,
}
